import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/event-item/event-item.js';
      import {EventItemType} from '@oicl/openbridge-webcomponents/dist/components/event-item/event-item.js';

      export interface Props {
     title?: string;
     description?: string;
     startTime?: string;
     endTime?: string;
     eventItemType?: EventItemType;
     hasArrow?: boolean;
     hasTime?: boolean;
     hasEndTime?: boolean;
     aggregatedCount?: number;
     colorCoded?: boolean;
     disabled?: boolean
   }

      
  
      export type {EventItemType} from '@oicl/openbridge-webcomponents/dist/components/event-item/event-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcEventItem',
  props: {
    title: {},
    description: {},
    startTime: {},
    endTime: {},
    eventItemType: {},
    hasArrow: { type: Boolean },
    hasTime: { type: Boolean },
    hasEndTime: { type: Boolean },
    aggregatedCount: {},
    colorCoded: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["event-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onEventClick: (event: CustomEvent<{title: string, startTime: string, endTime: string}>) => emit('event-click', event as CustomEvent<{title: string, startTime: string, endTime: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-event-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})